import "./features.scss";
import { onViewLoad } from "~/jose_modern/on_view_load.js";
require.context("./images", true);
require.context("./videos", true, /\.(mp4|webp)$/);

// Based on lozad.js, but stripped down to just what we need
function lazyLoadVideos() {
  const elements = document.querySelectorAll(".lazyload-video");

  if (!window.IntersectionObserver) {
    // Fallback: load all videos immediately for older browsers
    elements.forEach(loadVideo);
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadVideo(entry.target);
          observer.unobserve(entry.target);
        }
      });
    },
    {
      rootMargin: "50px", // Start loading 50px before the element comes into view
    }
  );

  elements.forEach((el) => observer.observe(el));

  function loadVideo(img) {
    const video = document.createElement("video");
    video.src = img.dataset.videoSrc;
    video.poster = img.src;
    video.autoplay = true;
    video.muted = true;
    video.loop = true;
    video.playsinline = true; // this must be all-lowercase, one word
    video.preload = "auto";

    // Copy over any classes from the image to the video
    if (img.className) {
      video.className = img.className.replace("lazyload-video", "");
    }

    // Copy width and height attributes to prevent layout shift
    video.width = img.width;
    video.height = img.height;

    let hasReplaced = false;

    function replaceWithVideo() {
      if (!hasReplaced) {
        hasReplaced = true;
        img.replaceWith(video);
      }
    }

    video.addEventListener("canplaythrough", replaceWithVideo);

    // Fallback if canplaythrough doesn't trigger. Unlikely to be encountered, but just in case.
    setTimeout(() => {
      if (!hasReplaced) {
        replaceWithVideo();
      }
    }, 2000);

    video.addEventListener("error", (e) => {
      console.error("Failed to load video:", video.src, e);
    });

    video.load();
  }
}

document.addEventListener("DOMContentLoaded", lazyLoadVideos);

onViewLoad("pages#costing", () => {
  const toggle = document.querySelector("[data-free-calculator-toggle]");
  const panel = document.getElementById(toggle.getAttribute("aria-controls"));
  const openLabel = toggle.textContent.trim();

  const setExpanded = (expanded) => {
    panel.classList.toggle("is-hidden", !expanded);
    toggle.setAttribute("aria-expanded", expanded);
    toggle.textContent = expanded ? "Hide the Calculator" : openLabel;
  };

  toggle.addEventListener("click", () => setExpanded(panel.classList.contains("is-hidden")));

  if (window.location.hash === `#${toggle.closest("section").id}`) {
    setExpanded(true);
  }
});
